import script from "./NotificationsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsCard.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsCard.vue?vue&type=style&index=0&id=c9d6781c&lang=css"

const __exports__ = script;

export default __exports__